export default __webpack_public_path__ + "SolutionFormationImages1.dddd1dd.png";